"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useLocalTheme = _interopRequireDefault(require("../../../hooks/useLocalTheme"));
var _DefaultSpec = _interopRequireDefault(require("./SpecTypes/DefaultSpec"));
var _ColorSpec = _interopRequireDefault(require("./SpecTypes/ColorSpec"));
var _EntertainmentSpec = _interopRequireDefault(require("./SpecTypes/EntertainmentSpec"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SpecContent = _ref => {
  let {
    label,
    value,
    productId,
    applyShowDifferences = false
  } = _ref;
  const specsHeadingWeight = (0, _useLocalTheme.default)(`comparison.specsHeadingWeight`, 3);
  const showColorToolTip = (0, _useLocalTheme.default)(`comparison.showColorToolTip`, false);
  switch (label) {
    case 'Colors':
      return /*#__PURE__*/_react.default.createElement(_ColorSpec.default, {
        value: value,
        productId: productId,
        showColorToolTip: showColorToolTip
      });
    case 'Entertainment':
      return /*#__PURE__*/_react.default.createElement(_EntertainmentSpec.default, {
        value: value
      });
    default:
      return /*#__PURE__*/_react.default.createElement(_DefaultSpec.default, {
        value: value,
        applyShowDifferences: applyShowDifferences,
        specsHeadingWeight: specsHeadingWeight
      });
  }
};
var _default = SpecContent;
exports.default = _default;